const subPageRoutes = [
  {
    path: 'user/tradingview-alert',
    element: 'TradingViewAlert',
    lazy: true,
  },
  { path: 'user/trusted-device', element: 'TrustedDevice', lazy: true },
  { path: 'user/subaccount-api-management', element: 'ApiManagement' },
  { path: 'user/add-secret-key', element: 'CreateApiPage' },
  { path: 'user/edit-secret-key', element: 'EditApiPage', lazy: true },
  { path: 'user/account-activity', element: 'AccountActivity' },
  {
    path: 'user/security/modify-password',
    element: 'ModifyPasswordPage',
    lazy: true,
    pageWrapperClass: 'modify-password-page',
  },
  {
    path: 'user/security/yubikey-management',
    redirect: '/app/user/security/passkey-management',
    replace: true,
  },
  {
    path: 'user/security/passkey-management',
    element: 'PasskeysManagement',
    lazy: true,
  },
  { path: 'user/bind-request', element: 'BindRequest', lazy: true },
  { path: 'user/auto-ban-account', element: 'AutoBanAccount', lazy: true },
  {
    path: 'user/auto-ban-account/:email_verify_token',
    element: 'AutoBanAccount',
    lazy: true,
  },
  { path: 'user/offline-verify', element: 'OfflineVerify', lazy: true },
  {
    path: 'user/offline-verify/:email_verify_token',
    element: 'OfflineVerify',
    lazy: true,
  },
  { path: 'user/api-broker', element: 'ApiBrokerDashboard', lazy: true }, // TODO:需要代理商帮忙测试
  { path: 'user/sub-account-login', element: 'SubAccountLogin' },
  { path: 'user/retrieve', element: 'Retrieve' },
  { path: 'user/oauth-admin', element: 'OauthAdmin', lazy: true },
  { path: 'user/trading-tool', element: 'TradingTool', lazy: true },
  // { path: 'user/audit/verify', element: 'AuditVerify', lazy: true },
  // {
  //   path: 'user/proof-of-reserve',
  //   element: 'Por',
  //   pageWrapperClass: 'proof-of-reserve-page',
  //   lazy: true,
  // },
  // {
  //   path: 'user/reserve-ratio',
  //   element: 'ReserveRatio',
  //   lazy: true,
  //   pageWrapperClass: 'reserve-ratio-page',
  // },
  // {
  //   path: 'user/audit-report',
  //   element: 'IndependentAuditReport',
  //   lazy: true,
  //   pageWrapperClass: 'audit-report-page',
  // },
  // { path: 'user/merkle-tree', element: 'MerkleTree', lazy: true },
  {
    path: 'user/withdraw-coins-setting',
    element: 'WithdrawCoinsSetting',
    lazy: true,
    pageWrapperClass: 'WithdrawCoinsSetting-page',
  },
  {
    path: 'user/primary-device',
    element: 'PrimaryDevice',
    lazy: true,
    pageWrapperClass: 'primary-device-page',
  },
  {
    path: 'user/delete-account',
    element: 'DeleteAccount',
  },
];

export default subPageRoutes;
